import React, { useState, Fragment, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { getLocalStorageItem, removeLocalStorageItem } from '../../../services/StorageService';
import { KpiPeopleHeader } from './KpiPeopleHeader';
import './style.scss';
import { getUserDetails } from '../../../config/utils';
import Header from '../../../containers/Header';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { MyKpis } from '../MyKpi';

export const KpiPeopleView: React.FC<any> = (props) => {
	const { enqueueSnackbar } = useSnackbar();
	const { listOkrResult } = props;
	const { t } = useTranslation();

	// const [isUnLockRequested, setIsUnLockRequested] = useState<Boolean>(false);
	const [modalProps, setModalProps] = useState<any>({ open: false, message: '' });
	const userDetail: any = getUserDetails();
	const currentYear: any = getLocalStorageItem('year') || null;
	const currentUser = getLocalStorageItem('currentUser')
		? JSON.parse(getLocalStorageItem('currentUser') || '{}')
		: null;
	useEffect(() => {
		window.addEventListener('scroll', scrollPeopleHeader);
		return () => {
			window.removeEventListener('scroll', scrollPeopleHeader);
		};
	});

	useEffect(() => {
		let unlockUser = getLocalStorageItem('unlockUser') || null;
		if (listOkrResult && listOkrResult.isLocked && unlockUser) {
			// setModalProps({
			// 	open: true,
			// 	message: isUnLockRequested ? t('request4AlreadyRaised') : t('request4Editing', { emailID: userDetail.emailId }),
			// 	unlockRequest: true,
			// });
			removeLocalStorageItem('unlockUser');
		}
	}, [listOkrResult]);

	const history = useHistory();
	useEffect(() => {
		document.body.classList.add('guideme-home');
		return () => {
			document.body.classList.remove('guideme-home');
		};
	}, [history.location]);

	const scrollPeopleHeader = (e: any) => {
		const objElement = document.getElementById('obj-header');
		const peopleElement = document.getElementById('people-header');
		const wrapElement = document.getElementById('wrap-container');
		if (window.pageYOffset >= 88) {
			peopleElement?.classList.add('sticky-header');
			objElement?.classList.add('sticky-header');
			wrapElement?.classList.add('sticky-bar-active');
		}
		if (window.pageYOffset < 70) {
			peopleElement?.classList.remove('sticky-header');
			objElement?.classList.remove('sticky-header');
			wrapElement?.classList.remove('sticky-bar-active');
		}
	};

	return (
		<Fragment>
			{/* {!showArchiveList && ( */}
			{currentUser && (
				<>
					<Box className='page-subheader' id='people-header'>
						<Box className='page-subheader-inner'>
							<Box className='page-subheader-left'>
								<Box className='page-subheader-title'>
									<Typography variant='h2'>{t('kpiLabel')}</Typography>
								</Box>
							</Box>
							<Box className='page-subheader-right'>
								<Header {...props} fromTab={true} />
							</Box>
						</Box>
					</Box>
					<KpiPeopleHeader {...props} currentUser={currentUser} />
					<Box className='pad-container'>
						<MyKpis
							{...props}
							setLoader={props.setLoader}
							drUserData={userDetail}
							tabValue={2}
							currentUser={currentUser}
						/>
					</Box>
				</>
			)}
		</Fragment>
	);
};
